export default __webpack_public_path__ + "static/media/InviteUser.ac2669ab.svg";